import React from 'react';
import { color as palette } from "@/constants/palette";

function UnCheckedbox() {
  return (
    <svg aria-hidden="true" focusable="false"
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='21'
      viewBox='0 0 20 21'
      fill='none'
    >
      <rect
        x='1.58203'
        y='2.08325'
        width='16.8333'
        height='16.8333'
        rx='3.25'
        fill='white'
        stroke={palette.line}
        strokeWidth='1.5'
      />
    </svg>
  );
}

export default UnCheckedbox;
